module.exports = __webpack_public_path__ + "img/syukyaku-top-g001.a7ffd7b5.png";